import { useEffect } from "react";
import { useClientBookingContext } from "@/contexts/clientBookingContext";

// make sure the provider selected is always eligible for current services
export default function useSelectEligibleProviderEffect() {
  const { setSelectedProvider, eligibleProviders, selectedProvider } =
    useClientBookingContext();

  useEffect(() => {
    if (
      selectedProvider &&
      !eligibleProviders.some((provider) => provider.id === selectedProvider.id)
    ) {
      setSelectedProvider(eligibleProviders?.[0]);
    }
  }, [eligibleProviders, selectedProvider, setSelectedProvider]);
}
